import run from './lib/run.js';

export default run;
